import logger from "@/libs/logger";
import {
  ApplicationInsights,
  IPageViewTelemetry,
} from "@microsoft/applicationinsights-web";
const appInsights: ApplicationInsights = new ApplicationInsights({
  config: {
    connectionString: process.env.REACT_APP_INSTRUMENTATION_KEY,
    enableAutoRouteTracking: false,
  },
});
handleTelemetry(() => appInsights.loadAppInsights(), "loadAppInsights");

export default appInsights;

function handleTelemetry(method: () => void, type: string) {
  try {
    method();
  } catch (error) {
    logger.error(`AppInsights ${type} failed:`, error);
  }
}

export const trackEvent = (
  name: string,
  properties = {},
  measurements = {}
) => {
  handleTelemetry(
    () => appInsights.trackEvent({ name, properties, measurements }),
    "trackEvent"
  );
};
export const trackPageView = (pageViewTelemetry: IPageViewTelemetry) => {
  handleTelemetry(
    () => appInsights.trackPageView(pageViewTelemetry),
    "trackPageView"
  );
};
export function clearUserIdAndSessionIdCookies() {
  const cookiesNameList = ["ai_session", "ai_user"];
  document?.cookie?.split(";")?.forEach((cookie) => {
    const cookieNameIndex = cookie.indexOf("=");
    const cookieName =
      cookieNameIndex > -1
        ? cookie.substring(0, cookieNameIndex).trim()
        : cookie.trim();
    if (cookiesNameList.includes(cookieName)) {
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    }
  });
}

export function setAuthenticatedUserContext(userId: string) {
  handleTelemetry(
    () => appInsights.setAuthenticatedUserContext(userId),
    "setAuthenticatedUserContext"
  );
}
export function clearAuthenticatedUserContext() {
  handleTelemetry(
    () => appInsights.clearAuthenticatedUserContext(),
    "clearAuthenticatedUserContext"
  );
}
